import * as React from 'react';

export const PreviewIcon = ({stroke = '#7f7f7f', size = 13, ...props}) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 12.867 12.908">
    <g transform="translate(-539.617 -369.652)">
      <path
        d="M0,1.955,1.955,0m0,0L3.909,1.955M1.955,0V8.8"
        transform="translate(548.22 371.152) rotate(45)"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="M3760.136,12328.583h-3.268a1.538,1.538,0,0,0-.781.437,1.836,1.836,0,0,0-.309.894v6.19a2.266,2.266,0,0,0,.242,1.113,1.681,1.681,0,0,0,.848.594h6.4l.874-.06a1.921,1.921,0,0,0,.467-.267c.228-.181.256-.941.256-.941v-2.864"
        transform="translate(-3215.409 -11956.001)"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </g>
  </svg>
);
